import * as Immutable from "immutable";
export const Properties = {
  Compound: "compound",
  Enumerable: "enumerable",
  FullTextSearch: "full-text-search",
  Numeric: "numeric",
  Decorated: "decorated"
};
const _FieldType = class _FieldType {
  constructor(type, properties, indexNames) {
    this.value = Immutable.Map({ type, properties: Immutable.Set(properties), indexNames: Immutable.Set(indexNames) });
  }
  get type() {
    return this.value.get("type");
  }
  get properties() {
    return this.value.get("properties");
  }
  get indexNames() {
    return this.value.get("indexNames");
  }
  isNumeric() {
    return this.properties.has(Properties.Numeric);
  }
  isEnumerable() {
    return this.properties.has(Properties.Enumerable);
  }
  isCompound() {
    return this.properties.has(Properties.Compound);
  }
  isDecorated() {
    return this.properties.has(Properties.Decorated);
  }
  static fromJSON(value) {
    const { type, properties, index_names } = value;
    return new _FieldType(type, properties, index_names);
  }
  static create(type, properties = [], indexNames = []) {
    return new _FieldType(type, properties, indexNames);
  }
};
_FieldType.Unknown = new _FieldType("unknown", [], []);
_FieldType.Decorated = new _FieldType("decorated field", [Properties.Decorated], []);
let FieldType = _FieldType;
export default FieldType;
const createType = (type, properties = []) => (indices = []) => FieldType.create(type, properties, indices);
export const FieldTypes = {
  STRING: createType("string", [Properties.Enumerable]),
  STRING_FTS: createType("string", [Properties.FullTextSearch]),
  LONG: createType("long", [Properties.Numeric, Properties.Enumerable]),
  INT: createType("int", [Properties.Numeric, Properties.Enumerable]),
  SHORT: createType("short", [Properties.Numeric, Properties.Enumerable]),
  BYTE: createType("byte", [Properties.Numeric, Properties.Enumerable]),
  DOUBLE: createType("double", [Properties.Numeric, Properties.Enumerable]),
  FLOAT: createType("float", [Properties.Numeric, Properties.Enumerable]),
  DATE: createType("date", [Properties.Enumerable]),
  BOOLEAN: createType("boolean", [Properties.Enumerable]),
  BINARY: createType("binary", []),
  GEO_POINT: createType("geo-point", []),
  IP: createType("ip", [Properties.Enumerable]),
  PERCENTAGE: createType("percentage", [Properties.Numeric])
};
